<template>
  <div>
    <div class="homepage-title">
      <h1 v-html="title"></h1>
    </div>
    <div class="content-col3">
      <div class="col" v-html="content"></div>
    </div>
    <hr style="margin: 20px;" />
  </div>
</template>

<script>
export default {
  name: 'Col3',

  data () {
    return {
    }
  },

  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: 'Content goes here'
    }
  }
}
</script>

<style>
.homepage-title {
  position: relative;
  margin-top: -60px;
  z-index: 5;
  display: block;
  padding-left: 35px;
  height: 70px;
  max-width: 40%;
  word-wrap: wrap;
}

.content-col3 .col p {
  margin-left: 15px;
  margin-right: 15px;
  padding-top: 0px;
  margin-top: 0px;
}

.call-to-action-btn {
  font-size: 13px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
}

.content-col3 {
  column-count: 1;
  padding: 20px;
}

.content-col3 .col {
  padding-bottom: 20px;
}

.content-col3 img {
  border-radius: 10px;
}

.content-col3 .training-btn,
.content-col3 .trainings-btn {
  width: 180px;
  background-color: #efefef;
  border-radius: 10px;
  height: 120px;
  padding-top: 15px;
  color: #000;
  margin-top: 10px;
}

.content-col3 .training-btn {
  margin-right: 30px;
}
.content-col3 .training-btn a,
.content-col3 .trainings-btn a {
  color: #000;
}

.content-col3 .training-btn:hover,
.content-col3 .training-btn:hover a,
.content-col3 .trainings-btn:hover,
.content-col3 .trainings-btn:hover a {
  background-color: #ce5e31;
  color: #fff;
  text-decoration: none;
  animation: changeBackground .5s linear;
}

.content-col3 .training-icon,
.content-col3 .trainings-icon {
  font-size: 30px;
}

.content-col3 .training-icon-box,
.content-col3 .trainings-icon-box {
  height: 50px;
}

@keyframes changeBackground {
  from {background-color: #efefef}
  to {background-color: #ce5e31}
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .content-col3 img {
    display: none;
  }

  .content-col3 {
    padding: 20px 30px 20px 20px;
  }

  .content-col3 .training-btn,
  .content-col3 .trainings-btn {
    width: 95%;
    margin-left: 20px;
    margin-right: 0px;
  }

  .homepage-title {
    max-width: 200px;
    height: auto;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .content-col3 img {
    display: none;
  }

  .content-col3 {
    padding: 20px 30px 20px 20px;
  }

  .content-col3 .training-btn,
  .content-col3 .trainings-btn {
    width: 95%;
    margin-left: 20px;
    margin-right: 0px;
  }

  .homepage-title {
    max-width: 200px;
    height: auto;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .content-col3 {
    column-count: 2;
    padding: 20px;
  }

  .content-col3 img {
    display: block;
    width: 100%;
  }

  .homepage-title {
    max-width: unset;
  }

  .content-col3 .training-btn,
  .content-col3 .trainings-btn {
    max-width: 180px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .content-col3 {
    column-count: 2;
    padding: 20px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .content-col3 {
    column-count: 3;
    padding: 20px;
    max-height: 380px;
    margin-bottom: 10px;
  }

  .content-col3 .training-btn,
  .content-col3 .trainings-btn {
    max-width: 150px;
    margin-bottom: 0px;
  }
}
</style>
